import {Divider as MantineDivider} from '@mantine/core';

/**
 * Horizontal/vertical rule — design-layer pass-through over Mantine `Divider`.
 * @registry Pass-through Mantine Divider; import this instead of @mantine/core outside src/design.
 */
export const Divider = MantineDivider;
